import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
	root: {
		width: 24,
		height: 24,
		// backgroundColor: '#BCBBD0',

		'& > svg': {
			// margin: theme.spacing(2),
			// width: 24,
			// height: 24,
		},
	},
}));

function ExitIcon(props) {
	return (
		<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M9 4C8.44771 4 8 3.55228 8 3C8 2.44772 8.44771 2 9 2L19 2C20.6569 2 22 3.34314 22 5L22 19C22 20.6569 20.6569 22 19 22L9 22C8.44772 22 8 21.5523 8 21C8 20.4477 8.44772 20 9 20L19 20C19.5523 20 20 19.5523 20 19L20 5C20 4.44772 19.5523 4 19 4L9 4Z" fill={props.fill} />
			<path opacity="0.5" fillRule="evenodd" clipRule="evenodd" d="M6.42157 11L12.0711 11C12.6234 11 13.0711 11.4477 13.0711 12C13.0711 12.5523 12.6234 13 12.0711 13L6.40685 13L7.53553 14.1287C7.92606 14.5192 7.92606 15.1524 7.53553 15.5429C7.14501 15.9334 6.51184 15.9334 6.12132 15.5429L3.29289 12.7145C2.90237 12.324 2.90237 11.6908 3.29289 11.3003L6.12132 8.47186C6.51184 8.08133 7.14501 8.08133 7.53553 8.47185C7.92606 8.86238 7.92606 9.49554 7.53553 9.88607L6.42157 11Z" fill={props.fill} />
		</svg>
	);
}

export default function SvgIconsColor(props) {
	const classes = useStyles();

	return (
		<div className={classes.root}>
			<ExitIcon fill={props.fill} />
		</div>
	);
}